import { sleep } from '@/utils/tools';

const TIME_OUT_CODE = 408;

export default function retry(request, config = {}, isSuccess) {
  const { times = 1, timeout = 10 * 1000, sleepTime = 1000 } = config;
  let count = 0;
  let startTime = Date.now();

  function isOverTime(startTime, timeout) {
    return Date.now() - startTime > timeout;
  }

  function _retry(params) {
    return new Promise((resolve, reject) => {
      // if (isOverTime(startTime, timeout)) {
      //   return resolve({ errno: TIME_OUT_CODE });
      // }

      request(params)
        .then(async (res) => {
          // 请求正常，业务层判断
          if (isSuccess(res)) {
            return resolve(res);
          }
          // 前端定义超时返回
          if (isOverTime(startTime, timeout)) {
            return resolve({ errno: TIME_OUT_CODE });
          }
          count++;
          if (count < times) {
            await sleep(sleepTime);
            return resolve(_retry(params));
          }
          return resolve(res);
        })
        .catch((err) => {
          // 请求异常，直接上抛
          reject(err);
        });
    });
  }

  return _retry;
}
